import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { ReviewedFundingRequestVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { retrieveReviewedFundingRequests } from "./retrieve-reviewed-funding-requests";

const initialState: RetrievalState<ReviewedFundingRequestVM[]> = {
  fetching: "idle",
  data: [],
};

export const retrieveReviewedFundingRequestsReducer = createReducer<RetrievalState<ReviewedFundingRequestVM[]>>(initialState, builder => {
  builder.addCase(retrieveReviewedFundingRequests.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveReviewedFundingRequests.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveReviewedFundingRequests.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
